import EscPosEncoder from 'esc-pos-encoder';
import {IInvoice} from "../@types";


export type ReceiptData = {
  companyName: string;
  receiptNo: string;
  invoiceNo: string;
  customerName: string;
  paymentMethod: string;
  datePaid: Date | string;
  balanceDue: string;
  items: Item[];
  total: string;
};

type Item = {
  name: string;
  amount: number;
  quantity: number;
  rate: number;
};
const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

export const encodeReceipt = async (receiptData: ReceiptData): Promise<Uint8Array> => {
  // @ts-ignore
  let encoder = new EscPosEncoder({
    width: 200
  });

  const receipt = encoder
    .initialize()
    .width(2)
    .height(2)
    .bold()
    .align('center')
    .size("normal")
    .text(receiptData.companyName)
    .bold(false)
    .newline()
    .newline()
    .width(1)
    .height(1)
    .text(`Receipt #: ${receiptData.receiptNo}`)
    .newline()
    .text(`Invoice #: ${receiptData.invoiceNo}`)
    .newline()
    .newline()
    .bold(true)
    .text(`Received From: `)
    .bold(false)
    .text(receiptData.customerName)
    .newline()
    .newline()
    .bold(true)
    .text(`DATE PAID: `)
    .bold(false)
    .text(<string>receiptData.datePaid ?? "")
    .newline()
    .newline()
    .bold(true)
    .text(`AMOUNT PAID:  `)
    .bold(false)
    .text(receiptData.total)
    .newline()
    .newline()
    .bold(true)
    .text(`PAYMENT METHOD:  `)
    .bold(false)
    .text(receiptData.paymentMethod)
    .newline()
    .newline()
    .bold(true)
    .text(`DATE PAID:  `)
    .bold(false)
    .text(` ${receiptData.datePaid}`)
    .newline()
    .newline()
    .bold(true)
    .text('SUMMARY')
    .bold(false)
    .newline()
    .newline()
    .align('center')
    .table(
      [
        {width: 10,  align: 'left'},
        {width: 10, align: 'right'}
      ],
      [
        ...receiptData.items.map(item => [
          `${item.name} x${item.quantity}`,
          `NGN${item.amount}`
        ]),
        [ '-'.repeat(25)],
        ['Total', (enc: EscPosEncoder) => enc.bold().text(`NGN${receiptData.total}`).bold()],
        [ '-'.repeat(25)],
      ]
    );

  return receipt
    .newline()
    .newline()
    .align('center')
    .size("normal")
    .text('Thanks you for choosing us')
    .newline()
    .text('Powered by esemie.io')
    .newline()
    .newline()
    .newline()
    .newline()
    .newline()
    .newline()
    .newline()
    .cut()
    .encode();
};



export const invoiceToReceiptData = (invoice: IInvoice, companyName: string): ReceiptData => {
  return {
    companyName: companyName?.toUpperCase(),
    receiptNo: "00034",
    invoiceNo: invoice.invoiceNumber,
    customerName: `${invoice.customer.firstName} ${invoice.customer.lastName}`,
    paymentMethod: "Cash",
    datePaid: new Date(invoice.createdAt).toLocaleDateString(),
    balanceDue: invoice.balanceDue,
    items: invoice.inventories.map(inventory => ({
      name: inventory.name,
      amount: inventory.rate * inventory.quantity,
      quantity: inventory.quantity,
      rate: inventory.rate
    })),
    total: invoice.inventories.reduce((total, inventory) => total + inventory.rate * inventory.quantity, 0).toString()
  };
}

